import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-punch-in-out',
  templateUrl: './punch-in-out.component.html'
})
export class PunchInOutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/time/components/punch-in-out/punch-in-out.component.ts